export default __webpack_public_path__ + "static/media/blue_3.png";